/**
 * Единый слой конверсии единиц. Вход конфигуратора — в сантиметрах (D7);
 * сцена — в метрах. Все переводы см↔м проходят здесь (без ручных /100 по коду).
 */

/** Сантиметры → метры. */
export const cmToMeters = (cm: number): number => cm / 100;

/** Метры → сантиметры. */
export const metersToCm = (m: number): number => m * 100;
